export const UnreceivedTransStatus = {
  UNSPECIFIED: 0,
  INITIATED: 1,
  PROCESSING: 2,
  PENDING: 3,
  SUCCESS: 4,
  FAILED: 5,
};

export const UnreceivedTransStatusMessage = {
  1: 'Chờ xử lý',
  2: 'Đang xử lý',
  3: 'Đang xử lý',
  4: 'Thành công',
  5: 'Thất bại',
};
